import { inject, Injectable } from '@angular/core';

import type { ConversationStarter } from '@core/tellent-assistant-types';
import { generateUuid } from '@core/utils-legacy';

import { AssistantRunService } from './run/assistant-run.service';
import { TellentAssistantThreadsService } from './tellent-assistant-threads.service';

@Injectable({ providedIn: 'root' })
export class TellentAssistantService {
  private readonly run = inject(AssistantRunService);
  private readonly threadsService = inject(TellentAssistantThreadsService);

  public readonly messages = this.run.messages;
  public readonly runStatus = this.run.runStatus;
  public readonly currentThreadId = this.run.currentThreadId;
  public readonly lastError = this.run.lastError;

  public send(text: string): void {
    if (this.run.runStatus() === 'running') return;
    this.run.send(text);
  }

  public sendStarter(starter: ConversationStarter): void {
    if (this.run.runStatus() === 'running') return;
    this.run.sendMessages(starter.messages);
  }

  public cancelRun(): void {
    this.run.cancelRun();
  }

  public newThread(): void {
    this.run.cancelRun();
    this.run.startNewThread(generateUuid());
  }

  public switchThread(id: string): void {
    this.run.cancelRun();
    this.run.switchToExistingThread(id);
    this.threadsService.loadCurrent(id);
  }
}
